import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        headerFields: [
            {
                name: "id",
                label: "Foglalás ID",
                filter: {
                    type: "simple"
                },
                sort: true,
                formVisible: false
            },
            {
                name: "appointmentDuration",
                label: "Időtartam",
                filter: {
                    type: "simple"
                },
                sort: true,
                event_payload: false,
                formRequired: false,
                formType: "number",
                formSize: 2,
                formVisible: true,
                numberStep: 5
            },
            {
                name: "appointment",
                label: "Dátum",
                filter: {
                    type: "simple"
                },
                sort: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 3,
                formVisible: true
            },
            {
                name: 'contactId',
                label: 'Megkeresés',
                visibility: false,
                formVisible: true,
                event_payload: "contactIdChange",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getContactsToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: 'partnerId',
                label: 'Partner',
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getPartnersToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "statusId",
                label: "Státusz",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAppointmentStatus,
                    formatText: function (val) {
                        if (val.text === 13) {
                            return '<div class="status-color status-approved"></div> Jóváhagyva';
                        }
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    formatOption: function (val) {
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true,
                event_name: "customChange",
                event_payload: "statusChange"
            },
            {
                name: "note",
                label: "Megjegyzés",
                filter: {
                    type: "simple"
                },
                sort: true,
                event_payload: false,
                formRequired: false,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                filter: {
                    type: "simple"
                },
                sort: true,
                event_payload: false,
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            }
        ],
        occupationHealthHeaderFields: [
            {
                name: "id",
                label: "Foglalás ID",
                sort: true,
                formVisible: false
            },
            {
                name: "doctorId",
                label: "Orvos",
                visibility: false,
                formVisible: true,
                formSize: 4,
                formType: 'select',
                formReadOnly: true,
                selectOptions: {
                    apiCallback: Api.getAllOccupationHealthDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "treatmentId",
                label: "Kezelés",
                sort: true,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getOccupationHealthTreatmentType,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
            {
                name: "appointmentDuration",
                label: "Időtartam",
                sort: true,
                event_payload: false,
                formRequired: false,
                formType: "number",
                formSize: 2,
                formVisible: true,
                numberStep: 5
            },
            {
                name: "appointment",
                label: "Dátum",
                sort: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 3,
                formVisible: true
            },
            {
                name: 'contactId',
                label: 'Megkeresés',
                visibility: false,
                formVisible: true,
                event_payload: "contactIdChange",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getContactsToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: 'partnerId',
                label: 'Partner',
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getPartnersToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "statusId",
                label: "Státusz",
                sort: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAppointmentStatus,
                    formatText: function (val) {
                        if (val.text === 13) {
                            return '<div class="status-color status-approved"></div> Jóváhagyva';
                        }
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    formatOption: function (val) {
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                event_name: "customChange",
                event_payload: "statusChange"
            },
            {
                name: "note",
                label: "Megjegyzés",
                sort: true,
                event_payload: false,
                formRequired: false,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                sort: true,
                event_payload: false,
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            }
        ],
        occupationHealthDoctorHeaderFields: [
            {
                name: "id",
                label: "Foglalás ID",
                sort: true,
                formVisible: false
            },
            {
                name: "doctorId",
                label: "Orvos",
                visibility: false,
                formVisible: true,
                formSize: 4,
                formType: 'select',
                formReadOnly: true,
                selectOptions: {
                    apiCallback: Api.getAllOccupationHealthDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "treatmentId",
                label: "Kezelés",
                sort: true,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getOccupationHealthTreatmentType,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
            {
                name: "appointmentDuration",
                label: "Időtartam",
                sort: true,
                event_payload: false,
                formRequired: false,
                formType: "number",
                formSize: 2,
                formVisible: true,
                numberStep: 5
            },
            {
                name: "appointment",
                label: "Dátum",
                sort: true,
                formRequired: true,
                formType: "dateTime",
                formSize: 3,
                formVisible: true
            },
            {
                name: 'contactId',
                label: 'Megkeresés',
                visibility: false,
                formVisible: true,
                event_payload: "contactIdChange",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getContactsToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: 'partnerId',
                label: 'Partner',
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getPartnersToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "statusId",
                label: "Státusz",
                sort: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAppointmentStatus,
                    formatText: function (val) {
                        if (val.text === 13) {
                            return '<div class="status-color status-approved"></div> Jóváhagyva';
                        }
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    formatOption: function (val) {
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                event_name: "customChange",
                event_payload: "statusChange"
            },
            {
                name: "note",
                label: "Megjegyzés",
                sort: true,
                event_payload: false,
                formRequired: false,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                sort: true,
                event_payload: false,
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            }
        ],
    }
}
